import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAI } from "@/lib/ai";

export const AISettingsCard = () => {
  const { enabled, aiOn, setConsent } = useAI();
  if (!enabled) return null;

  const toggle = async (on) => {
    try {
      await setConsent(on);
      toast.success(on ? "AI assistance turned on" : "AI assistance turned off");
    } catch {
      toast.error("Could not update AI preference");
    }
  };

  return (
    <Card className="border border-zinc-200" data-testid="ai-settings-card">
      <CardContent className="p-5">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-start gap-2">
            <Sparkles className="w-4 h-4 text-zinc-400 mt-0.5" />
            <div>
              <h3 className="text-sm font-heading font-semibold text-zinc-900">AI features</h3>
              <p className="text-[11px] text-zinc-500 leading-relaxed mt-0.5">
                Uses a third-party AI service to analyze photos and job details.
              </p>
            </div>
          </div>
          <Switch checked={aiOn} onCheckedChange={toggle} data-testid="ai-consent-toggle" />
        </div>
      </CardContent>
    </Card>
  );
};
